import axios from 'axios';
import { config } from '../config';

let AuthModel;

AuthModel = {};

axios.defaults.baseURL = config.$api_url;
axios.defaults.timeout = config.timeoutDuration;

AuthModel.login = function (user) {
    console.log('Logging into API');
    
    return axios.post('/oauth/token', user)
}

export { AuthModel }


// WEBPACK FOOTER //
// ./src/api-services/auth.service.js